import type { ThemeConfig } from 'antd';

export const THEME_CONFIG: ThemeConfig = {
    token: {
        colorPrimary: '#6B7432',
        colorText: '#1A201A',
        fontFamily: 'Roboto',
        fontSizeHeading1: 38,
        fontSizeHeading2: 30,
        fontSizeHeading3: 24,
        fontSizeHeading4: 20,
        fontSizeHeading5: 16,
        fontSize: 16,
        controlHeight: 32,
        borderRadius: 2,
    },
    components: {
        Button: {
            borderRadius: 8,
            fontSize: 14,
            fontSizeLG: 16,
            borderRadiusLG: 8,
            borderRadiusSM: 8,
            colorPrimary: '#EEF2CB',
            colorPrimaryHover: '#c9d373',
            colorPrimaryActive: '#8A9345',
            primaryColor: '#6B7432',
            primaryShadow: 'none',
            defaultHoverColor: '#444A20',
            defaultHoverBorderColor: '#444A20',
            defaultActiveColor: '#292D13',
            defaultActiveBorderColor: '#292D13',
        },
        Input: {
            fontSize: 14,
        },
        InputNumber: {
            fontSize: 14,
        },
        Select: {
            fontSize: 14,
            optionSelectedBg: '#EEF2CB',
            optionSelectedColor: '#6B7432',
        },
        DatePicker: {
            fontSize: 14,
        },
        Menu: {
            itemColor: '#1A201A',
            itemSelectedColor: '#6B7432',
            itemSelectedBg: '#EEF2CB',
            subMenuItemSelectedColor: '#6B7432',
        },
    },
};
